/** Placeholder swapped for the per-request nonce before HTML is sent. */
export const CSP_NONCE_PLACEHOLDER = '__CSP_NONCE__';

/** Meta name Emotion and other runtime style injectors read. */
export const CSP_NONCE_META_NAME = 'csp-nonce';

type CspNonceDocument = {
  querySelector(selectors: string): { getAttribute(name: string): string | null } | null;
};

/**
 * Read the document nonce published in `<meta name="csp-nonce">`.
 * Returns undefined when the tag is missing or still contains the placeholder,
 * so dev HTML that Vite serves unreplaced does not stamp a fake nonce.
 */
export function readCspNonce(doc: CspNonceDocument | undefined | null): string | undefined {
  if (!doc) return undefined;
  const content = doc
    .querySelector(`meta[name="${CSP_NONCE_META_NAME}"]`)
    ?.getAttribute('content')
    ?.trim();
  if (!content || content === CSP_NONCE_PLACEHOLDER) return undefined;
  return content;
}
